// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u7cw","title":"styles_title__TVioN"};